import { request } from "../../core";

export function login(data) {
  return request.post({
    url: "/api/ums/login",
    data,
  });
};

export function getUserInfo() {
  return request.post({
    url: "/api/ums/getUserInfo",
  });
};

export function logout() {
  return request.post({
    url: "/api/ums/logout",
  });
};

export function checkLogin(param) {
  const { token } = param;
  return request.post({
    token,
    url: "/api/ums/checkLogin",
    handleError: true,
  });
};
